<p>jeeves-credit-blocked-checker works!</p>
